export default {
  changelogs: {
    date_deploy: 'Fecha: {{period}}',
    enhancement: 'Mejoras',
    fix: 'Fixes',
    new_feature: 'Nuevas funcionalidades',
    title: 'Historial de mejoras'
  }
};
